






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Route, RouteConfig } from 'vue-router';
import { PermissionModule } from '@/store/modules/permission';
import AppSidebarSingleItem from './AppSidebarSingleItem.vue';
import AppSidebarGroupItem, {
  showItem,
  getSingleItem,
  isSingleItem,
} from './AppSidebarGroupItem.vue';

@Component({
  name: 'AppSidebarItems',
  components: {
    AppSidebarSingleItem,
    AppSidebarGroupItem,
  },
})
export default class extends Vue {
  get routes() {
    return PermissionModule.routes;
  }

  private showItem(item: RouteConfig) {
    return showItem(item);
  }

  private getSingleItem(item: RouteConfig) {
    return getSingleItem(item) as RouteConfig;
  }

  private isSingleItem(item: RouteConfig) {
    return isSingleItem(item);
  }
}
